module.exports = __webpack_public_path__ + "img/1440x480 Site.03481b38.png";